import type { UserRole } from '@/types/auth';
import { clientPaths } from '@/utils/clientPaths';

export function getDefaultHomePath(role: UserRole, slug?: string | null): string {
  switch (role) {
    case 'customer':
      return clientPaths.home;
    case 'community':
      return '/host';
    case 'owner':
    case 'staff':
      return slug ? `/admin/${slug}` : '/admin';
    case 'superadmin':
      return '/superadmin';
    default:
      return '/';
  }
}

/** Tab Home saat buka app / fallback deeplink. Login customer tetap ke `/event`. */
export function getAppLaunchHomePath(role: UserRole, slug?: string | null): string {
  if (role === 'customer') {
    return clientPaths.home;
  }
  return getDefaultHomePath(role, slug);
}
